/**
 * Meilenstein im Kalender auf einen anderen Tag ziehen (F-25). Ziel ist
 * jedes Element mit `data-tag="YYYY-MM-DD"` (Meilenstein-Zeile der Woche,
 * Tageszelle im Monat). Ohne Bewegung bleibt es ein Klick zur Projektseite.
 * Ohne Maus aendert man das Datum wie bisher auf der Projektseite.
 */
import { updateMilestone } from '@/db/repositories/milestones';
import { isLocalDate } from '@/lib/datetime';
import type { MeilensteinItem } from '@/domain/projects/meilensteine';

const SCHWELLE_PX = 6;

function tagUnter(x: number, y: number): HTMLElement | null {
  return (document.elementFromPoint(x, y) as HTMLElement | null)?.closest<HTMLElement>('[data-tag]') ?? null;
}

export function beginMeilensteinZiehen(e: React.PointerEvent, m: MeilensteinItem): void {
  if (e.button !== 0 || e.pointerType === 'touch') return;
  const start = { x: e.clientX, y: e.clientY };
  let aktiv = false;
  let ziel: HTMLElement | null = null;

  const setzeZiel = (neu: HTMLElement | null) => {
    if (neu === ziel) return;
    ziel?.removeAttribute('data-zieh-ziel');
    ziel = neu;
    ziel?.setAttribute('data-zieh-ziel', '');
  };
  const bewegen = (ev: PointerEvent) => {
    if (!aktiv && Math.hypot(ev.clientX - start.x, ev.clientY - start.y) < SCHWELLE_PX) return;
    aktiv = true;
    document.body.style.cursor = 'grabbing';
    setzeZiel(tagUnter(ev.clientX, ev.clientY));
  };
  const ende = () => {
    window.removeEventListener('pointermove', bewegen);
    window.removeEventListener('pointerup', loslassen);
    window.removeEventListener('keydown', taste);
    document.body.style.cursor = '';
  };
  const loslassen = () => {
    const tag = ziel?.dataset.tag;
    setzeZiel(null);
    ende();
    if (!aktiv) return;
    // Der folgende Klick gehoert zum Ziehen, nicht zur Navigation.
    window.addEventListener('click', (c) => { c.preventDefault(); c.stopPropagation(); }, { capture: true, once: true });
    if (tag && isLocalDate(tag) && tag !== m.date) void updateMilestone(m.projectId, m.id, { date: tag });
  };
  const taste = (ev: KeyboardEvent) => {
    if (ev.key !== 'Escape') return;
    aktiv = false;
    setzeZiel(null);
    ende();
  };
  window.addEventListener('pointermove', bewegen);
  window.addEventListener('pointerup', loslassen);
  window.addEventListener('keydown', taste);
}
